import { inTestEnvironment } from '../../shared/javascripts/util/environment.js'
import { trackElementInteraction } from './util/analytics'

up.on('up:link:follow', (event) => {
  let link = event.target
  let href = link.getAttribute('href')
  trackElementInteraction(link, 'click.link', { link: { href } })
})

$(document).on('click', 'a', (event) => {
  let link = event.currentTarget
  let href = link.href

  let currentHost = window.location.host
  let targetHost = link.host

  if (targetHost !== '' && targetHost !== currentHost) {
    // We want to inspect the event in tests, so we prevent following the external link
    if (inTestEnvironment()) {
      event.preventDefault()
    }
    trackElementInteraction(link, 'externalLink.click', { link: { href } })
  }
})
